/* eslint-disable */
import { mapGetters } from "vuex";
import mixins from '@/mixins/mixins';
import _ from 'lodash';


export default {
  mixins:[mixins],
  computed: {
    ...mapGetters([
      'get_shipment_editing_mode',
      'get_editing_shipment',
      'get_booking_systems',
    ]),
  },
  created() {
    //Display errors must be in created hook, message must be initiated in at component create
    if(this.get_shipment_editing_mode && this.get_editing_shipment.errorStatuses.length > 0){
      let message = '<div>';
      this.get_editing_shipment.errorStatuses.forEach((error) => {
        const agentName = (this.get_editing_shipment.shippingAgentName && parseInt(error.status_id) === 36)
          ? `${this.get_editing_shipment.shippingAgentName} :` : '';
        message += `${agentName} ${error.message}</br>`;
      })
      message += '</div>';

      if (this.get_editing_shipment.shipmentType === 'draft') {
        this.draftError = message
      } else {
        // this.$store.commit('SHOW_NOTIFICATION_BAR', {
        //   message: message,
        //   type: 'alert-window',
        // });
      }
    }
  },
  mounted() {
    if( this.get_shipment_editing_mode ){
      // console.log('UCITAJ EDITING')
      this.draftShippmentId = this.get_editing_shipment.draftShippmentId;
      // PLACE DATA FROM EDITING OBJECT

      // Set shipping date
      this.shippingDate = this.get_editing_shipment.shippingDate.split(' ')[0];
      if(this.isBefore(new Date(this.shippingDate), new Date())) {
        this.shippingDate = new Date();
      }

      // Set shipper
      this.$store.dispatch('GET_SHIPPERS').then((res) => {
        this.shipperOptions = [
          {value: null, text: 'Other address', country: ''},
          ...res.map((opt) => {
            return {
              value: opt.id,
              country: opt.country_id ? this.getCountry(opt.country_id, 'alpha2') : '',
              text: `
                ${opt.company_name ? opt.company_name + ', ' : ''}
                ${opt.name ? opt.name + ', ' : ''}
                ${opt.address_1 ? opt.address_1 + ', ' : ''}
                ${opt.post_code ? opt.post_code + ', ' : ''}
                ${opt.city ? opt.city + ', ' : ''}
                ${opt.state ? opt.state + ', ' : ''}
                ${opt.country_id ? this.getCountry(opt.country_id, 'name') : ''}
              `
            };
          }),
        ];
        this.shipper = this.get_editing_shipment.shipper;
        this.foreignShipper = this.get_editing_shipment.foreignShipper;
      });
      // Set customer - from
      this.fromAddress = this.get_editing_shipment.fromAddress;
      this.fromData = this.get_editing_shipment.fromData;

      // Flag is return shipment
      this.isReturn = this.get_editing_shipment.isReturn;
      this.editShipmentDroppointNo = this.get_editing_shipment.droppointNo;
      // Set customer - to
      this.toAddress = this.get_editing_shipment.toAddress;
      this.toData = this.get_editing_shipment.toData;

      // Set goods
      this.activeGoodsTypes = this.get_editing_shipment.activeGoodsTypes;
      this.$store.dispatch('GET_PARCEL_TYPES').then(() => {

      })

      //https://stackoverflow.com/questions/68774950/strange-console-log-output-with-vuex
      this.shipmentPackages = _.cloneDeep(this.get_editing_shipment.storeShipmentPackages);

      // Set customs - invoicing
      this.customsData.goods_incoterm = this.get_editing_shipment.customsData.goods_incoterm;
      this.customsData.duty_paid_by = this.get_editing_shipment.customsData.duty_paid_by;
      this.customsData.duty_payer_account_no = this.get_editing_shipment.customsData.duty_payer_account_no;
      this.customsData.freight_paid_by = this.get_editing_shipment.customsData.freight_paid_by;
      this.customsData.freight_payer_account_no = this.get_editing_shipment.customsData.freight_payer_account_no;
      this.customsData.freight_payer_id = this.get_editing_shipment.customsData.freight_payer_id;

      // custom tags
      this.custom_tag_json = this.get_editing_shipment.custom_tag_json;
      this.custom_tag_json_tmp = JSON.parse(JSON.stringify(this.get_editing_shipment.custom_tag_json));
      this.$store.dispatch('GET_BOOKING_SYSTEMS').then((res) => {
        if(res.items.length > 0){
          this.isSenderReferenceRequired = res.items[0].is_shipper_reference_required;
          this.isReceiverReferenceRequired = res.items[0].is_receiver_reference_required;
          this.showColliAmount = res.items[0].show_booking_colli_amount;
          this.systemShowColliContent = res.items[0].show_booking_colli_content;
          this.showInfoBox = res.items[0].show_booking_info_box;
          this.isPhoneRequired = res.items[0].is_phone_required;
          this.isEmailRequired = res.items[0].is_email_required;
        }
      });
      // services
      this.feeIdsJson = null;//this.get_editing_shipment.apiFeeIds;
      this.active_services_json = this.get_editing_shipment.apiActiveServices; //active_services_view
      this.selectedProduct = this.get_editing_shipment.selectedProduct;
      this.additionalServicesFieldsData = Object.keys(this.get_editing_shipment.additionalServicesData).length
        ? this.get_editing_shipment.additionalServicesData
        : {};
      this.pickupDriverNote = this.get_editing_shipment.pickupDriverNote;
      this.pickupTimeUntil = this.get_editing_shipment.pickupTimeUntil;
      this.pickupTimeFrom = this.get_editing_shipment.pickupTimeFrom;
    } else {
       //console.log('UCITAJ BLANKO')
      // SET SHIPPER OPTIONS
      this.cachedShipper = this.shipper;
      this.$store.dispatch('GET_SHIPPERS').then((res) => {
        this.shipperOptions = [
          {value: null, text: 'Other address', country: ''},
          ...res.map((opt) => {
            return {
              value: opt.id,
              country: opt.country_id ? this.getCountry(opt.country_id, 'alpha2') : '',
              text: `
                ${opt.company_name ? opt.company_name + ', ' : ''}
                ${opt.name ? opt.name + ', ' : ''}
                ${opt.address_1 ? opt.address_1 + ', ' : ''}
                ${opt.post_code ? opt.post_code + ', ' : ''}
                ${opt.city ? opt.city + ', ' : ''}
                ${opt.state ? opt.state + ', ' : ''}
                ${opt.country_id ? this.getCountry(opt.country_id, 'name') : ''}
              `
            };
          }),
        ];
        if(this.shipper !== '' && this.shipper !== null && this.shipper !== 'custom'){
          this.isShipperInFrom = true;
          this.changeAddress('from', {...res.filter(opt => opt.id === this.shipper)[0], typeOfAction: 'app'});
        }
      });
      // SET PARCEL TYPES
      this.$store.dispatch('GET_PARCEL_TYPES');
      // SET TAGS
      this.$store.dispatch('GET_BOOKING_SYSTEMS').then((res) => {
        if(res.items.length > 0){
          this.custom_tag_json = res.items[0].custom_tag_json;
          this.custom_tag_json_tmp = JSON.parse(JSON.stringify(res.items[0].custom_tag_json));
          this.isSenderReferenceRequired = res.items[0].is_shipper_reference_required;
          this.isReceiverReferenceRequired = res.items[0].is_receiver_reference_required;
          this.showColliAmount = res.items[0].show_booking_colli_amount;
          this.systemShowColliContent = res.items[0].show_booking_colli_content;
          this.showInfoBox = res.items[0].show_booking_info_box;
          this.isPhoneRequired = res.items[0].is_phone_required;
          this.isEmailRequired = res.items[0].is_email_required;
        }
      });
      // Set date
      let freshDate = new Date();
      let d = new Date();
      if (freshDate.getDay() == 6) {
        d.setDate(freshDate.getDate() + 2);
      }

      if (freshDate.getDay() == 0) {
        d.setDate(freshDate.getDate() + 1);
      }

      let month = '' + (d.getMonth() + 1);
      let day = '' + d.getDate();
      let year = d.getFullYear();
      if (month.length < 2)
          month = '0' + month;
      if (day.length < 2)
          day = '0' + day;

      this.shippingDate = [year, month, day].join('-');

      // USE DATA FROM APPLICATION
      // Set reference
      this.fromData.reference = this.get_user.shipper_reference ?? '';
      this.toData.reference = this.get_user.receiver_reference ?? '';
      this.defaultPackageBlocks.parcel.description = this.get_user.description ?? '';

      // Set shipper
      this.shipper = this.get_user.sender_id;
      if(this.shipper === null) this.foreignShipper = true;
    }
    this.shipmentPopup = this.get_user.label_printer_id === null ? true : false;
    this.show_has_temperature = this.get_user.show_has_temperature;
    this.show_dangerous_goods = this.get_user.show_dangerous_goods;
    this.show_other_shipper_address = this.get_user.show_other_shipper_address;
    this.show_freight_paid_by = this.get_user.show_freight_paid_by;
    this.show_incoterms = this.get_user.show_incoterms;
    this.book_permission_type = this.get_user.book_permission_type;
  },
  methods: {
    isBefore(date1, date2) {
      return date1 < date2;
    }
  },
}
